// Carga perezosa del player lottie-web desde CDN (unpkg), cacheando la promesa.
// Copia byte-fiel de la función inline usada en Marketing/SAC/ClientGeneral; se extrae
// aquí para que AsyncStateView (y futuros consumidores) la reusen sin duplicar. Los 3
// usos inline existentes NO se migran (fuera de alcance): mantienen su propia copia.
const LOTTIE_SCRIPT_SRC =
  'https://unpkg.com/lottie-web@5.12.2/build/player/lottie.min.js';
let lottieScriptPromise;

export const loadLottiePlayer = () => {
  if (typeof window === 'undefined') return Promise.resolve(null);
  if (window.lottie) return Promise.resolve(window.lottie);
  if (!lottieScriptPromise) {
    lottieScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = LOTTIE_SCRIPT_SRC;
      script.async = true;
      script.onload = () => resolve(window.lottie || null);
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }
  return lottieScriptPromise;
};
